var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-checkbox',{staticClass:"f-checkbox-d",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color,"hide-details":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }